import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// --- IMPORT YOUR PAGES ---
import Login from "./pages/Login";
import Home from "./pages/Home";
import Prapt_Aai from "./pages/Prapt_Aai"; // <--- IMPORT THIS
import Kharch_Aai from "./pages/Kharch_Aai";
import AddNewUser from "./pages/AddNewUser";
import AnnualReport from "./pages/AnnualReport";
import IncomeReport from "./pages/IncomeReport";
import ExpenseReport from "./pages/ExpenseReport"; // <-- 1.
import DeleteEntry from "./pages/DeleteEntry";
import AayVyayPatrak from "./pages/AayVyayPatrak";
// --- IMPORT GUARDS ---
import PrivateRoute from "./pages/PrivateRoute";
import PublicRoute from "./pages/PublicRoute";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public: Login */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />

        {/* Private: Home */}
        <Route
          path="/home"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />

        {/* --- FIX: ADD ROUTES THAT MATCH YOUR HOME.JS LINKS EXACTLY --- */}

        {/* 1. Add New User */}
        <Route
          path="/add-new-user"
          element={
            <PrivateRoute>
              <AddNewUser />
            </PrivateRoute>
          }
        />

        {/* 2. Kharch Aai (Expense) */}
        {/* NOTE: Home.js says '/kharch-aai', so we MUST use that path here */}
        <Route
          path="/kharch-aai"
          element={
            <PrivateRoute>
              <Kharch_Aai />
            </PrivateRoute>
          }
        />

        {/* 3. Prapt Aai (Income) - Create this file if missing */}
        <Route
          path="/prapt-aai"
          element={
            <PrivateRoute>
              <Prapt_Aai />
            </PrivateRoute>
          }
        />

        <Route
          path="/annual-report"
          element={
            <PrivateRoute>
              <AnnualReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/income-report"
          element={
            <PrivateRoute>
              <IncomeReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/expense-report"
          element={
            <PrivateRoute>
              <ExpenseReport />
            </PrivateRoute>
          }
        />

        <Route
          path="/delete-entry"
          element={
            <PrivateRoute>
              <DeleteEntry />
            </PrivateRoute>
          }
        />
        <Route
          path="/aay-vyay-patrak"
          element={
            <PrivateRoute>
              <AayVyayPatrak />
            </PrivateRoute>
          }
        />

        {/* Catch-All: Sends unknown links to Login */}
        <Route path="*" element={<Login />} />
      </Routes>
    </Router>
  );
}

export default App;
